import Loading from 'components/common/Loading';

import dayjs from 'dayjs';
import React, { Key } from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import { GET, contractEndReasonOptions, contract_start_reason, employment_contract, personalData, professional_status } from 'utils';
import { api } from 'utils/apiRoutes';
import { CustomInput } from '../../../custom';
import Options from 'components/form/register/Options';
import CustomDropdown from 'components/dropdown/custom_select';

const MainHistory = ({ id }: { id: number }) => {
  const { data, status } = useQuery('get-employee-history', async () => {
    return await GET(`${api.usersList}${id}`);
  });
  const rowStyle: React.CSSProperties = {
    padding: '0.75rem 1rem',
    color: '#000'
  };
  const item = data?.data as personalData;
  console.log(item);

  if (status === 'loading') return <Loading />;
  return (
    <div
      style={{ marginTop: '4.5rem', gap: '2rem' }}
      className="is-flex is-flex-direction-column"
    >
      <Card style={{ background: '#FFF' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '10%' }}>
            <img
              style={{ borderRadius: '50%' }}
              height={105}
              width={105}
              alt="avatar"
              src={
                item.avatar
                  ? item.avatar['url']
                  : item.title === 'male'
                    ? '/assets/Businessman.png'
                    : '/assets/Businesswoman.png'
              }
            />
          </div>
          <div style={{ width: '100%' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(8, minmax(0, 1fr))',
                gap: '25px',
              }}
            >
              <div style={{ gridColumn: 'span 2 / span 2' }}>
                <CustomInput
                  value={item.title === 'male' ? 'Male' : 'Female'}
                  title="Title"
                  height="50px"
                  fontSize={12}
                  readOnly
                  width="100%"
                />
              </div>
              <div style={{ gridColumn: 'span 3 / span 3' }}>
                <CustomInput
                  value={item.last_name}
                  title={'Last name'}
                  required
                  height="50px"
                  fontSize={12}
                  width="100%"
                />
              </div>
              <div style={{ gridColumn: 'span 3 / span 3' }}>
                <CustomInput
                  value={item.first_name}
                  title={'First name'}
                  required
                  height="50px"
                  fontSize={12}
                  width="100%"
                />
              </div>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(8, minmax(0, 1fr))',
                gap: '25px',
                marginTop: '30px',
              }}
            >
              <div style={{ gridColumn: 'span 2 / span 2' }}>
                <CustomInput
                  readOnly
                  value={item.job_number}
                  title={'ID Number'}
                  required
                  height="50px"
                  fontSize={12}
                  width={'100%'}
                />
              </div>

              <div style={{ gridColumn: 'span 3 / span 3' }}>
                <CustomInput
                  value={item.email}
                  title={'Email address'}
                  required
                  height="50px"
                  fontSize={12}
                  width={'100%'}
                />
              </div>
            </div>
          </div>
        </div>
        <table className="mt-5" style={{ width: '100%' }}>
          <thead>
            <tr
              style={{
                background: '#EAF6FF',
                borderRadius: '0.375rem 0.375rem 0rem 0rem',
              }}
            >
              <th style={rowStyle} >
                Department
              </th>
              <th style={rowStyle} >
                Job Title
              </th>
              <th style={rowStyle} >
                Service
              </th>
              <th style={rowStyle} >
                User Profile
              </th>
              <th style={rowStyle} >
                Change Date
              </th>
            </tr>
          </thead>
          <tbody>
            {item['position_histories'].map(
              (p: {
                id: Key;
                department: {
                  name: string;
                };
                job_title: string;

                service: {
                  name: string;
                };
                role: string;
                changed_at: string | number | Date | dayjs.Dayjs;
              }) => (
                <tr key={p.id}>
                  <td style={{ color: '#407FDD', padding: '0.75rem 1rem' }}>
                    {p.department?.name}
                  </td>
                  <td style={rowStyle} >
                    {p.job_title}
                  </td>
                  <td style={rowStyle} >
                    {p.service?.name}
                  </td>
                  <td
                    style={rowStyle}
                  >
                    {p.role.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                  </td>
                  <td style={rowStyle} >
                    {dayjs(p.changed_at).format('YYYY-MM-DD')}
                  </td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </Card>
      <Card>
        <h1 style={{ fontSize: '1.25rem' }}>
          <strong style={{ color: '#000000' }}>Civil Status</strong>
        </h1>
        <div
          className={' mt-6'}
          style={{
            gap: 32,
            display: 'grid',
            gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
          }}
        >
          <div style={{ gridColumn: 'span 2 / span 2' }}>
            <CustomInput
              title={'Social Security Number'}
              required
              readOnly
              height="50px"
              fontSize={12}
              width="100%"
              value={item.social_security_number}
            />
          </div>
          <div style={{ gridColumn: 'span 2 / span 2' }}>
            <CustomInput
              title={'Nationality'}
              readOnly
              width="100%"
              height="50px"
              fontSize={12}
              value={item.nationality}
            />
          </div>
          <div style={{ gridColumn: 'span 2 / span 2' }}>
            <CustomInput
              title={'Birth Name'}
              readOnly
              width="100%"
              height="50px"
              fontSize={12}
              value={item.birth_name}
            />
          </div>
        </div>
        <div
          className={' mt-5'}
          style={{
            gap: 32,
            display: 'grid',
            gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
          }}
        >
          <div style={{ gridColumn: 'span 2 / span 2' }}>
            <CustomInput
              title={'Date of Birth'}
              readOnly
              height="50px"
              fontSize={12}
              value={item.date_of_birth}
              width="100%"
            />
          </div>

          <div
            style={{
              gridColumn: 'span 2 / span 2',
              display: 'grid',
              gap: 8,
              gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
            }}
          >
            <CustomInput
              title={'City of Birth'}
              readOnly
              height="50px"
              fontSize={12}
              width={'100%'}
              value={item.birth_city}
            />
            <CustomInput
              title={'Birth department number'}
              readOnly
              height="50px"
              fontSize={12}
              width={'100%'}
              value={item.birth_department}
            />
          </div>

          <div
            style={{
              gridColumn: 'span 2 / span 2',
            }}
          >
            <CustomInput
              title={'Country of Birth'}
              readOnly
              height="50px"
              fontSize={12}
              width={'100%'}
              value={item.birth_country}
            />
          </div>
        </div>
      </Card>
      <Card style={{ marginBottom: '30px' }}>
        <h1 style={{ fontSize: '1.25rem' }}>
          <strong style={{ color: '#000' }}>Contract</strong>
        </h1>
        <div
          className={'mt-6 '}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 32,
          }}
        >
          <div
            style={{
              gridColumn: 'span 1 / span 1',
            }}
          >
            <CustomInput
              title={'Start Date at company'}
              readOnly
              width="100%"
              height="50px"
              fontSize={12}
              value={item.contract_start_date}
            />
          </div>
        </div>
        <div className={'my-5'}>
          <span style={{ fontSize: '1rem', color: '#000', fontWeight: 500 }}>
            On-going Contract
          </span>
        </div>
        <div
          style={{
            gap: 32,
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          }}
        >
          <div
            style={{
              gridColumn: 'span 1 / span 1',
            }}
          >
            <CustomInput
              title={'Contract Start Date'}
              readOnly
              height="50px"
              fontSize={12}
              width="100%"
              value={item.contract_start_date}
            />
          </div>
          <div
            style={{
              gridColumn: 'span 1 / span 1',
            }}
          >
            {/* <CustomInput
              title={'Contract Start Reason'}
              readOnly
              height="50px"
              fontSize={12}
              width="100%"
              value={item?.contract_start_reason?.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
            /> */}
            <CustomDropdown
              title={'Contract Start Reason'}
              height="50px"
              options={contract_start_reason}
              defaultKey={item?.contract_start_reason}
              disabled
              fontSize={12}
            />
          </div>
        </div>{' '}
        <div className={'is-flex my-5'} style={{ gap: 32 }}>
          <CustomInput
            title={'Contract End Date'}
            readOnly
            height="50px"
            fontSize={12}
            width='100%'
            value={item.contract_end_date}
          />
          {/* <CustomInput
            title={'Contract End Reason'}
            readOnly
            height="50px"
            fontSize={12}
            value={item?.contract_end_reason?.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
          /> */}
          <CustomDropdown
            title={'Contract End Reason'}
            height="50px"
            options={contractEndReasonOptions}
            defaultKey={item?.contract_end_reason}
            disabled
            width='100%'
            fontSize={12}
          />
        </div>
        <div className={'is-flex'} style={{ width: '60%', gap: 32 }}>
          {/* <CustomInput
            title={'Employment Contract'}
            readOnly
            height="50px"
            fontSize={12}
            value={item?.employment_contract?.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
          /> */}
          <CustomDropdown
            title={'Employment Contract'}
            height="50px"
            options={employment_contract}
            defaultKey={item?.employment_contract}
            disabled
            width='100%'
            fontSize={12}
          />
          {/* <CustomInput
            title={'Professional Status'}
            readOnly
            height="50px"
            fontSize={12}
            width="45%"
            value={item?.professional_status?.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
          /> */}
          <CustomDropdown
            title={'Professional Status'}
            height="50px"
            options={professional_status}
            defaultKey={item?.professional_status}
            disabled
            width='100%'
            fontSize={12}
          />
        </div>
      </Card>
    </div>
  );
};
const Card = styled.div`
  padding: 2rem;
  box-shadow: 0 2px 8px 0 rgba(14, 48, 99, 0.25);
  border-radius: 6px;
`;
export default MainHistory;
